import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  Stack,
  Alert,
} from '@mui/material';
import { Code as CodeIcon, ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';
import { useBuild } from '../contexts/BuildContext';
import BackendCallDialog from '../components/BackendCallDialog';

const ScoringInfoColumn = () => {
  const { scoringResults, scoringLastCall } = useBuild();
  const [backendCallDialogOpen, setBackendCallDialogOpen] = useState(false);

  const handleOpenBackendCallDialog = () => {
    setBackendCallDialogOpen(true);
  };

  const handleCloseBackendCallDialog = () => {
    setBackendCallDialogOpen(false);
  };

  const renderInfo = () => {
    if (!scoringResults) {
      return (
        <Typography variant="body2" color="text.secondary">
          No query executed yet.
        </Typography>
      );
    }

    // Show error message if there's an error in scoringResults
    if (scoringResults?.error) {
      return (
        <Stack spacing={2}>
          {/* Backend Call Button - always enabled when there's an error */}
          <Button
            variant="outlined"
            startIcon={<CodeIcon />}
            onClick={handleOpenBackendCallDialog}
            fullWidth
          >
            Backend Call
          </Button>

          <Alert severity="error">
            <Typography variant="subtitle2" gutterBottom>
              Query Error
            </Typography>
            <Typography variant="body2">
              {scoringResults.error}
            </Typography>
          </Alert>
        </Stack>
      );
    }

    if (!scoringResults.result) {
      return (
        <Typography variant="body2" color="text.secondary">
          No query executed yet.
        </Typography>
      );
    }

    const tookBackend = scoringResults.took_backend ?? 0;
    return (
      <Stack spacing={2}>
        {/* Backend Call Button */}
        <Button
          variant="outlined"
          startIcon={<CodeIcon />}
          onClick={handleOpenBackendCallDialog}
          fullWidth
          disabled={!scoringLastCall}
        >
          Backend Call
        </Button>

        <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
          <ArrowDownwardIcon color="action" />
        </Box>

        <Box>
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Frontend</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {scoringResults.took_frontend || 0}ms
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Backend</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {tookBackend ?? 0}ms
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    );
  };

  return (
    <>
      <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h6" gutterBottom>
          Information
        </Typography>
        
        <Box sx={{ mt: 2, flex: 1, overflow: 'auto' }}>
          {renderInfo()}
        </Box>

        {/* Backend Call Dialog */}
        <BackendCallDialog
          open={backendCallDialogOpen}
          onClose={handleCloseBackendCallDialog}
          apiCall={scoringLastCall}
          maxWidth="md"
        />
      </Paper>
    </>
  );
};

export default ScoringInfoColumn;
